import connectedStore from '../../store/connected-store';
import getDialogVisibility from '../selectors/dialog-visibility';

const isDialogVisible = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return Boolean(getDialogVisibility(state));
};

export default isDialogVisible;
